// GAP SSG/prerender production (gaponline.pl). Shared WAR CSR uses environment.prod.ts.
export const environment = {
  baseUrl: 'https://gaponline.pl',
  formBaseUrl: 'https://gaponline.pl',
  apiBase: 'https://gaponline.click/api',
  apkUrl: 'https://gwarancjeonline.pl',
  production: true,
  hmr: false,
  hotjar: '2094485',
  homeFtp: false,
  COOKIEBOT_ID: '3b201a50-5d73-4b69-87ce-61c8b23cca70',
  analyticsDebug: false,
  trustBadgeId: 'XB7B9D5A9A472D57D8E5D13B45673A7C4',
  SENTRY_MONITORING: true,
  SENTRY_AUTH_TOKEN:
    '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',
  SELLER_NODE_CODE: 'iDefend-25297',
  classicGap: true,
  ocrActive: false,
  recaptchaSiteKey: "6LfCIyIsAAAAAHa34eyOr5oq4R3h9kOtRBBAT3Ch",
};
